import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import 'boxicons/css/boxicons.min.css';

// Component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Footer = () => {
  const { t } = useTranslation();

  const mainProductLinks = [
    { name: t('header.productLinks.desiccants'), path: "/products/desiccants" },
    { name: t("header.productLinks.containerSafetySheets"), path: "/products/container-safety-sheet" },
    { name: t('header.productLinks.bigBag'), path: "/products/big-bag" },
  ];

  return (
    <>
      <ScrollToTop />
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-12 footer-contact mb-4 mb-lg-0">
                <h3>DEKO INDUSTRIEBEDARF GmbH</h3>
                <p>
                  Deko Industriebedarf GmbH<br />
                  Am Hagelkreuz 23<br />
                  41469 Neuss<br />
                  Germany<br /><br />
                  <strong>Email:</strong> <a href={`mailto:${t('topbar.email')}`} className="footer-email-link">{t('topbar.email')}</a><br />
                </p>
              </div>

              <div className="col-lg-3 col-md-6 footer-links mb-4 mb-md-0">
                <h4>{t('footer.usefulLinks')}</h4>
                <ul>
                  <li><i className="bx bx-chevron-right"></i> <Link to="/">{t('header.home')}</Link></li>
                  <li><i className="bx bx-chevron-right"></i> <Link to="/products">{t('header.products')}</Link></li>
                  <li><i className="bx bx-chevron-right"></i> <Link to="/quality">{t('header.quality')}</Link></li>
                  <li><i className="bx bx-chevron-right"></i> <Link to="/industries">{t('header.industries')}</Link></li>
                  <li><i className="bx bx-chevron-right"></i> <Link to="/about">{t('header.about')}</Link></li>
                  <li><i className="bx bx-chevron-right"></i> <Link to="/contact">{t('header.contact')}</Link></li>
                </ul>
              </div>

              <div className="col-lg-4 col-md-6 footer-links">
                <h4>{t('footer.ourProducts')}</h4>
                <ul>
                  {mainProductLinks.map((product, index) => (
                    <li key={index}><i className="bx bx-chevron-right"></i> <Link to={product.path}>{product.name}</Link></li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="container footer-bottom clearfix">
          <div className="copyright">
            &copy; {t('footer.copyright')} {new Date().getFullYear()} <strong><span>DEKO GmbH</span></strong>. {t('footer.allRightsReserved')}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;